export default __webpack_public_path__ + "static/media/image 75.07b5a91c.webp";